interface MutationObserverOptions {
  mutationType?: string;
  childList?: boolean;
  subtree?: boolean;
  [key: string]: any;
}

export const mutationObserver = (selector: string, callback: (element: Element) => void, options: MutationObserverOptions = {
  mutationType: 'childList',
  childList: true,
  subtree: true
}) => {
  const { mutationType, ...observeOptions } = options

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === mutationType) {
        const element = document.querySelector(selector)
        if (element) {
          callback(element)
          observer.disconnect()
          break
        }
      }
    }
  })

  observer.observe(document.body, observeOptions)
}
